import script from "./not-found.vue?vue&type=script&lang=tsx"
export * from "./not-found.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__